import React, {
  Dispatch,
  FC,
  SetStateAction,
  ChangeEvent,
  useMemo,
} from 'react';
import Card from '../../BaseComponents/Card';
import Button from '../../BaseComponents/Button';
import TextInput from '../../BaseComponents/TextInput';
import './LoginForm.scss';

interface IProps {
  setIsFormSubmitted: Dispatch<SetStateAction<boolean>>;
  formik: any;
  isLoading: boolean;
}

const LoginForm: FC<IProps> = ({ formik, isLoading }) => {
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (formik.errors.email && formik.submitCount > 0) {
      formik.setFieldError('email', '');
    }
    formik.handleChange(e);
  };

  const isDisabled = useMemo(
    () => !!(!formik.values.email || formik.errors.email),
    [formik.errors.email, formik.values.email]
  );

  return (
    <div>
      <Card backgroundColor={'rgba(247, 249, 252, 1)'}>
        <div className='login-card-container'>
          <div className='login-text-wrapper'>
            <p className='card-title'>Login</p>
            <p className='card-subtitle'>
              Enter your email to receive a code and log in.
            </p>
          </div>
          <form onSubmit={formik.handleSubmit} noValidate>
            <div className='form-elements'>
              <TextInput
                name='email'
                placeholder='Enter email'
                type='email'
                isError={formik.submitCount > 0 && !!formik.errors.email}
                errorMessage={
                  formik.submitCount > 0 ? formik.errors.email : undefined
                }
                onChange={handleEmailChange}
                value={formik.values.email}
              />
              <Button
                text='Get magic link'
                type='submit'
                isTall={true}
                isLoading={isLoading}
                isDisabled={isDisabled}
              />
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default LoginForm;
